import type { Theme } from '@mui/material/styles';

/** גודל אייקון ה־i בטריגר טולטיפ — פיקסלים לוגיים, נכנס ל־rem דרך הערכת (ללא `em`, בלי הפרש רינדור ראשון). */
export const INFO_TOOLTIP_TRIGGER_ICON_PX = 14;

/** אייקונים בתוך גוף הטולטיפ — מעט קטן יותר מהטריגר */
export const INFO_TOOLTIP_INLINE_ICON_PX = 13;

export function infoTooltipTriggerIconSize(theme: Theme): string {
  return theme.typography.pxToRem(INFO_TOOLTIP_TRIGGER_ICON_PX);
}

export function infoTooltipInlineIconSize(theme: Theme): string {
  return theme.typography.pxToRem(INFO_TOOLTIP_INLINE_ICON_PX);
}
